/**
 * React.js Utility functions.
 */

"use strict";

import isArray from "lodash/isArray";
import toPairs from "lodash/toPairs";

const ReactUtils = {};

/**
 * Escapes a string to allow use in HTML.
 */
ReactUtils.escapeHTML = function (unsafe) {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

/**
 * Creates an array of <option> elements based on the given
 * object mapping or array of key value pairs.
 *
 * If emptyLabel is provided (not undefined), an additional option is created
 * with an empty key and the emptyLabel string.
 */
ReactUtils.createSelectOptionList = function (keyValuePairs, emptyLabel) {
  if (!isArray(keyValuePairs)) {
    keyValuePairs = toPairs(keyValuePairs);
  }

  const opts = keyValuePairs.map(function (v) {
    return (
      <option key={v[0]} value={v[0]}>
        {v[1]}
      </option>
    );
  });

  if (emptyLabel !== undefined) {
    opts.unshift(
      <option key="" value="">
        {emptyLabel}
      </option>
    );
  }

  return opts;
};

/* generate unique key for each invocation and prefix */
ReactUtils.Key = {
  counters: {},
  get: function (prefix) {
    if (this.counters[prefix] === undefined) {
      this.counters[prefix] = 0;
    }
    this.counters[prefix]++;
    return prefix + "-" + this.counters[prefix];
  },
};
//****************************
//* EXPORTS
//****************************

export default ReactUtils;
